<template>
  <div>
    <v-main>
      <v-container fluid>
        <app-headline :title="title" />

        <leave-header :info="otherData" />

        <leave-cancel
          type="1"
          :title="formTitle"
          @updateOtherData="onUpdateOtherData"
          @updateLoading="onUpdateLoading"
        />
      </v-container>
    </v-main>

    <div
      v-show="loading"
      style="position: fixed; bottom: 4px; left: 4px; z-index: 5;"
    >
      <v-progress-circular indeterminate color="primary" />
    </div>
  </div>
</template>

<script>
import LeaveHeader from '@/components/leave/LeaveHeader'
import LeaveCancel from '@/components/leave/LeaveForm/LeaveCancel'

export default {
  components: {
    LeaveHeader,
    LeaveCancel
  },

  data() {
    return {
      loading: true,
      otherData: {}
    }
  },

  computed: {
    title() {
      return this.isEditMode
        ? 'แก้ไขการขอยกเลิกวันลา - ' + this.$route.params.leaveOrderId
        : 'การขอยกเลิกวันลา'
    },

    formTitle() {
      return this.isEditMode
        ? 'แก้ไขแบบฟอร์มการยกเลิกวันลา - ' + this.$route.params.leaveOrderId
        : 'แบบฟอร์มการยกเลิกวันลา'
    },

    isEditMode() {
      return !!this.$route.params.leaveOrderId
    }
  },

  methods: {
    onUpdateOtherData(otherData) {
      this.otherData = otherData
    },

    onUpdateLoading(loading) {
      this.loading = loading
    }
  }
}
</script>
